<div bsModal #purchaseAssessment="bs-modal" id="purchaseAssessment" class="modal fade" (onShown)="onShown()" role="dialog" aria-labelledby="purchaseAssessment"
     aria-hidden="true" [config]="{backdrop: 'static'}" style="overflow: auto;">
    <div class="modal-dialog">
        <div #modalContent class="modal-content" style="overflow: hidden;">
            <div class="modal-header text-center">
                <button type="button" class="close" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h2 class="modal-title text-center">Purchase Assessments</h2>
            </div>

            <div class="modal-body" style="padding: 10px 15px 0 15px; ">
                <ng-container *ngIf="purchaseAssessments">
                    <div class="row">
                        <div class="col-xs-6" style="padding:0 7.5px 0 0 ;">
                            <div class="border row text-center" *ngIf="eliAssessment.length > 0">
                                <div class="col-12">
                                    <label class="assessmentTitle">{{eliAssessment[0].Name}}</label>
                                </div>

                                <div class="col-12" style="margin: auto; text-align: justify; width: 95px;">
                                    <div style="display: grid;">
                                        <div style="display:flex;" *ngFor="let price of eliAssessment[0].Pricing">
                                            <div style="width:55px;"><span>{{(price.RangeEnd==0)? '+' + (price.RangeStart - 1) : price.RangeStart}}</span>{{(price.RangeEnd==0)? '': '-'}}<span>{{(price.RangeEnd==0)? '': price.RangeEnd}}</span></div><span style="width:10px;"> : </span><span style="font-weight:bold;"> ${{price.Price}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12" style="margin-top:10px;">
                                    <div>
                                        <label>Quantity: </label>
                                        <input #_quantity inputmode="numeric" type="number" step="1" min="1" value="1" max="999" id="quantity" style=""/>
                                    </div>
                                    <div style="margin-top:10px;">
                                        <button (click)="addOrder(false, _quantity.value)" class="btn btn-primary waves-effect">Add to order</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="col-xs-6" style="padding:0 0 0 7.5px;">
                            <div class="border text-center row" *ngIf="assessment360.length > 0">

                                <div class="col-12">
                                    <label class="assessmentTitle">{{assessment360[0].Name}} Assessment</label>
                                </div>

                                <div class="col-12" style="margin: auto;text-align: justify; width: 95px;">
                                    <div style="display: grid;">
                                        <div style="display:flex;" *ngFor="let price of assessment360[0].Pricing">
                                            <div style="width:55px;"><span>{{(price.RangeEnd==0)? '+' + (price.RangeStart - 1) : price.RangeStart}}</span>{{(price.RangeEnd==0)? '': '-'}}<span>{{(price.RangeEnd==0)? '': price.RangeEnd}}</span></div><span style="width:10px;"> : </span><span style="font-weight:bold;"> ${{price.Price}}</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-12" style="margin-top:10px;">
                                    <div>
                                        <label>Quantity: </label>
                                        <input #_quantity360 inputmode="numeric" type="number" step="1" min="1" value="1" max="999" id="quantity360" style=""/>
                                    </div>
                                    <div class="text-center" style="margin-top:10px;">
                                        <button (click)="addOrder(true, _quantity360.value)" class="btn btn-primary waves-effect">Add to order</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </ng-container>

                <h4 style="margin: 10px 0;">Order</h4>

                <div style="height: 145px; overflow-y: hidden;">
                    <div style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="false"
                                         [gridOptions]="gridOptions"
                                         [rowData]="orders"
                                         [columnDefs]="ordersHeaders"
                                         [enableSorting]="false"
                                         [enableColResize]="false"
                                         (rowClicked)="onRowClicked($event)"
                                         (gridReady)="onGridReady($event)"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate">
                        </ag-grid-angular>
                    </div>
                </div>

                <div class="text-right">
                    <ng-container *ngIf="discounts.length > 0">
                        <div><b>Subtotal:</b> <span class="purchaseValues">${{total}}</span></div>
                        <div *ngFor="let discount of discounts">
                            <b>{{discount.DiscountType}}:</b> <span class="purchaseValues">${{(total * discount.DiscountPercent / 100) | number : '1.0-2'}}</span>
                        </div>
                    </ng-container> 

                    <div><b>Total:</b> <span class="purchaseValues">${{total - (total * totalDiscount / 100) | number : '1.0-2'}}</span></div>
                </div>

                <ng-container *ngIf="askingQuestions">
                    <!--in questions-->
                    <b><span>Survey</span></b>
                    <p>Question {{questionIndex+1}}/{{questionsData.length}}</p>
                    <p>{{questionsData[questionIndex].questionText}}</p>
                    <select class="questions">
                        <option *ngFor="let answer of questionsData[0].answers" value="value">{{answer}}</option>
                    </select>
                </ng-container>

                <ng-container *ngIf="finishPurchase">
                    <!--after questions-->
                    <b><span>Finish</span></b>
                    <div class="m-auto">
                        <p>You are about to purchase N version 2.0 General assessments.</p>
                        <p>Your credit card on file will be charged $50.00</p>
                    </div>
                </ng-container>
            </div>

            <div class="modal-footer text-right">
                <ng-container *ngIf="purchaseAssessments">
                    <!--before questions-->
                    <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />
                    <!--<input (click)="saveAssessmentPurchase()" type="button" class="btn btn-primary waves-effect" value="Check Out" />-->
                    <input (click)="openModal()" type="button" class="btn btn-primary waves-effect" value="Checkout" />
                    <!--//(click)="continue()"-->
                </ng-container>

                <ng-container *ngIf="askingQuestions">
                    <!--in questions-->
                    <input type="button" (click)="nextQuestionIndex()" class="btn btn-primary waves-effect" value="Next" />
                </ng-container>

                <ng-container *ngIf="finishPurchase">
                    <!--after questions-->
                    <input (click)="close()" type="button" class="btn" name="close" value="Cancel" />
                    <input (click)="close()" type="button" class="btn btn-primary waves-effect" value="Ok" />
                </ng-container>
            </div>
        </div>
    </div>
</div>

<!--FORM MODAL-->
<div class="modal fade" id="formModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" style="background-color: #0000009a;">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div *ngIf="loading" class="backdrop">
                <div class="text-center">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="color:#46a8ce; font-size: 75px;"></i>
                    <p>Processing transaction, please wait...</p>
                </div>
            </div>

            <div class="modal-header">
                <div class="text-center">
                    <h3 class="modal-title text-center"><span class="capitalize"></span>Payment Details</h3>
                </div>
                <button (click)="closeModal()" type="button" class="close" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!-- CREDIT CARD FORM STARTS HERE -->
            <div class="panel panel-default credit-card-box">
                <!--<div class="panel-heading display-table">
                    <div class="row display-tr">
                        <div class="display-td">
                            <img class="img-responsive pull-right" src="https://i76.imgup.net/accepted_c22e0.png">
                        </div>
                    </div>
                </div>-->
                <div class="panel-body">
                    <form class="animated bounceInUp" *ngIf="!addingNewCreditCard" action="" method="POST" id="payment-form" (submit)="purchaseProcess()">
                        <!--<div class="modal-body">-->

                        <div class="row">
                            <div class="col-xs-7 col-md-7">
                                <label style="font-size: 18px;">AMOUNT: </label>
                                <span style="font-size: 18px;"><b>${{total}}</b></span>
                            </div>
                            <div class="col-xs-5 col-md-5" style="text-align: right;">
                                <!--<a class="pointer" id="addNewCard" (click)="addNewCard()">Add New Card</a>-->
                                <a (click)="addNewCard()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                                    <i class="fas fa-plus text-white-50"> <span class="button-text"> Add New Card</span></i>
                                </a>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom: 10px;">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label for="cardNumber">SELECT CREDIT CARD</label>
                                    <div class="col-md-12 noPadding" style="display:flex;">
                                        <select style="width: calc(100% - 75px);" class="form-control" required autofocus id="cardNumber"
                                                *ngIf="coachCreaditCards.length > 0; else noCreditCard"
                                                (change)="changeCreditCard($event)">
                                            <option *ngFor="let cc of coachCreaditCards; let i = index" [selected]="cc.Id==selectedCreditCardId"
                                                    [value]="cc.Id">
                                                {{cc.Last4Digits}}
                                            </option>
                                        </select>
                                        <ng-template #noCreditCard>
                                            <input style="width: calc(100% - 75px);" class="form-control customPlaceHolder"
                                                   type="text"
                                                   placeholder="No credit cards on file" readonly />
                                        </ng-template>

                                        <div id="cardIcon" style="
                                        background-image: url(../../assets/img/cards.png);
                                        background-position: 0px 0px;
                                        background-size: 60px;
                                        background-repeat: no-repeat;
                                        height: 40px; width: 60px; margin-left: 15px;"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ng-container *ngIf="coachCreaditCards.length > 0">
                            <div class="row">
                                <div class="col-xs-12 col-md-8">
                                    <div class="row" style="line-height: 1; position: relative; top: 8px;">
                                        <div class="col-xs-12">
                                            <div class="form-group">
                                                <label class="width130">Name on card: </label>
                                                <span>{{selectedCreditCard.cardUserName}}</span>
                                            </div>
                                        </div>
                                        <div class="col-xs-12">
                                            <div class="form-group">
                                                <label class="width130" for="cardExpiry">Expiration Date:</label>
                                                <span>{{selectedCreditCard.expiryMonth}}/{{selectedCreditCard.expiryYear}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-md-4">
                                    <div class="col-xs-12 col-md-12 pull-right">
                                        <div class="form-group" style="display: flex; position: relative;top: 9px;">
                                            <label id="labelCardCVC" style="line-height: 1; margin-right: 15px;" for="cardCVC"><span style="color:red;">*</span>CVV</label>
                                            <input class="form-control"
                                                   style="width: 120px;"
                                                   placeholder="CVV"
                                                   id="cardCVC"
                                                   autocomplete="cc-csc"
                                                   required
                                                   [(ngModel)]="selectedCreditCard.cvc"
                                                   name="cvc"
                                                   type="tel"
                                                   maxlength="4"
                                                   data-stripe="cvc"
                                                   (keypress)="validateNumber($event)"
                                                   (keydown)="validateNumber($event)"
                                                   inputmode="numeric" pattern="[0-9]*" digitOnly />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="row formContent" style="padding: 0 15px; position: relative; top: 10px;margin-bottom: 15px;">
                                <label>BILLING ADDRESS</label>
                                <div>
                                    <div class="col-xs-12 col-md-12">
                                        <div class="form-group" style="display: flex;">
                                            <label><span style="color:red;">*</span>Address Line 1: </label>
                                            <input class="form-control"
                                                   [(ngModel)]="selectedCreditCard.address1"
                                                   id="billAddress1"
                                                   #billAddress1
                                                   size="30"
                                                   name="streetAddress1"
                                                   required
                                                   (keypress)="preventSpace(billAddress1.value, $event)"
                                                   (keyup)="preventSpace(billAddress1.value, $event)"
                                                   placeholder="Address Line 1"
                                                   type="text">
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div class="col-xs-12 col-md-12">
                                        <div class="form-group">
                                            <label>Address Line 2:</label>
                                            <input class="form-control"
                                                   [(ngModel)]="selectedCreditCard.address2"
                                                   id="billAddress2"
                                                   size="30"
                                                   #billAddress2
                                                   (keypress)="preventSpace(billAddress2.value, $event)"
                                                   (keyup)="preventSpace(billAddress2.value, $event)"
                                                   name="streetaddress2"
                                                   placeholder="Optional Address Line 2"
                                                   type="text">
                                        </div>
                                    </div>
                                </div>

                                <div class="row noPadding">
                                    <div class="col-xs-12 col-md-6 cPadding" style="padding: 0 0 0 15px;">
                                        <div class="form-group">
                                            <label><span style="color:red;">*</span>City:</label>
                                            <input class="form-control"
                                                   [(ngModel)]="selectedCreditCard.city"
                                                   id="billCity"
                                                   required
                                                   #city
                                                   (keypress)="preventSpace(city.value, $event)"
                                                   (keyup)="preventSpace(city.value, $event)"
                                                   name="city"
                                                   placeholder="City"
                                                   type="text">
                                        </div>
                                    </div>

                                    <div class="col-xs-12 col-md-6">
                                        <div class="form-group">
                                            <label style="width: 110px;">State/Province:</label>
                                            <input class="form-control" style="width: calc(100% - 110px);"
                                                   [(ngModel)]="selectedCreditCard.state"
                                                   id="state"
                                                   size="30"
                                                   #state
                                                   (keypress)="preventSpace(state.value, $event)"
                                                   (keyup)="preventSpace(state.value, $event)"
                                                   name="state"
                                                   placeholder="State"
                                                   type="text">
                                        </div>
                                    </div>
                                </div>

                                <div class="row noPadding">
                                    <div class="col-xs-12 col-md-6 cPadding" style="padding: 0 0 0 15px;">
                                        <div class="form-group">
                                            <label><span style="color:red;">*</span>Country:</label>
                                            <select [(ngModel)]="selectedCreditCard.country"
                                                    class="form-control"
                                                    id="countrySelect"
                                                    #countrySelect
                                                    name="country" required="">
                                                <option *ngFor="let country of countryList; let i = index" [selected]="country == selectedCreditCard.country"
                                                        [value]="country">
                                                    {{country}}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-xs-12 col-md-6">
                                        <div class="form-group">
                                            <label style="width: 110px;"><span style="color:red;">*</span>Zip Code:</label>
                                            <input class="form-control" style="width: calc(100% - 110px);"
                                                   [(ngModel)]="selectedCreditCard.zipCode"
                                                   id="billZip"
                                                   size="15"
                                                   required
                                                   #billZip
                                                   (keypress)="preventSpace(billZip.value, $event)"
                                                   (keyup)="preventSpace(billZip.value, $event)"
                                                   name="postalCode"
                                                   placeholder="Zip or Postal Code"
                                                   type="text">
                                        </div>
                                    </div>
                                </div>

                                <!--<div>
                                    <div class="col-xs-12 col-md-12">
                                        <div class="form-group">
                                            <label><span style="color:red;">*</span>Phone Number:</label>
                                            <input class="form-control"
                                                   [(ngModel)]="selectedCreditCard.phone"
                                                   id="phoneNumber"
                                                   required
                                                   #phoneNumber
                                                   (keyup)="preventSpace(phoneNumber.value, $event)"
                                                   (keypress)="preventLetters($event)"
                                                   name="phoneNumber"
                                                   placeholder="Phone Number"
                                                   type="tel">
                                        </div>
                                    </div>
                                </div>-->
                                <!--<div>
                                    <div class="col-xs-12 col-md-12">
                                        <div class="form-group" style="margin-bottom: -9px;">
                                            <label><span style="color:red;">*</span>Email Address:</label>
                                            <input class="form-control"
                                                   [(ngModel)]="selectedCreditCard.email"
                                                   id="emailAddress"
                                                   required
                                                   #emailAddress
                                                   (keypress)="preventSpace(emailAddress.value, $event)"
                                                   (keyup)="preventSpace(emailAddress.value, $event)"
                                                   name="emailAddress"
                                                   placeholder="Email Address"
                                                   type="email">
                                        </div>
                                    </div>
                                </div>-->
                            </div>
                        </ng-container>


                        <!--<span class="payment-message">{{message}}</span>-->
                        <!--</div>-->

                        <div class="modal-footer noPadding" style="padding: 15px 0 0 0 !important;">
                            <input type="button" (click)="closeModal()" class="btn btn-secondary" name="close" value="Cancel" />
                            <input [disabled]="loading" type="submit" value="Complete Purchase" class="btn btn-primary waves-effect" />
                            <!--<input disabled type="submit" value="Complete Purchase" class="btn btn-primary waves-effect" />-->
                        </div>

                    </form>

                    <form class="animated bounceInDown" *ngIf="addingNewCreditCard">
                        <h4>New card</h4>

                        <div>
                            <div class="col-xs-12 col-md-12">
                                <div class="form-group">
                                    <label>CARD NUMBER: </label>
                                    <div>
                                        <input type="text" id="newCardNumber" required=""
                                               placeholder="Credit Card Number"
                                               value="" class="form-control"
                                               (keyup)="validateCard()"
                                               [(ngModel)]="newCreditCard.number"
                                               name="cardNumber"
                                               inputmode="numeric" pattern="[0-9]*" digitOnly
                                               style="background-image: url(../../assets/img/cards.png); background-position: 3px 3px; background-size: 40px 252px; background-repeat: no-repeat; padding-left: 48px; border: 1px solid rgb(204, 204, 204); outline: 0px; box-shadow: none;">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="col-xs-12 col-md-12">
                                <div class="form-group">
                                    <label>NAME ON CARD: </label>
                                    <div>
                                        <input [(ngModel)]="newCreditCard.name"
                                               #nameOnCard
                                               class="form-control" id="newNameOnCard"
                                               size="30" required="" placeholder="Full Name on Card"
                                               (keypress)="preventSpace(nameOnCard.value, $event)"
                                               (keyup)="preventSpace(nameOnCard.value, $event)"
                                               value="" name="cardName" type="text">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="col-xs-12 col-md-12">
                                <div class="form-group">
                                    <label>CARD TYPE: </label>
                                    <div>
                                        <input [(ngModel)]="newCreditCard.type" name="cardType"
                                               class="form-control" id="newCardType"
                                               type="text" readonly
                                               placeholder="Credit Card Type"
                                               style="cursor: not-allowed;">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-7 col-md-7">
                                <div class="form-group">
                                    <label for="cardExpiry"><span class="hidden-xs">EXPIRATION</span><span class="visible-xs-inline">EXP</span> DATE</label>
                                    <div style="display: flex;">
                                        <select [(ngModel)]="newCreditCard.month" class="form-control"
                                                style="margin: inherit; width: 88% !important; margin-left: 6px;"
                                                id="newExpirationMonth" name="cardMonth" required="">
                                            <option value="1">01 - January</option>
                                            <option value="2">02 - February</option>
                                            <option value="3">03 - March</option>
                                            <option value="4">04 - April</option>
                                            <option value="5">05 - May</option>
                                            <option value="6">06 - June</option>
                                            <option value="7">07 - July</option>
                                            <option value="8">08 - August</option>
                                            <option value="9">09 - September</option>
                                            <option value="10">10 - October</option>
                                            <option value="11">11 - November</option>
                                            <option value="12">12 - December</option>
                                        </select>
                                        <select [(ngModel)]="newCreditCard.year"
                                                class="form-control" style=" width: 88% !important; margin-left: 6px;"
                                                id="newExpirationYear" name="cardYear" required="">
                                            <option *ngFor="let y of createRange(31); let i = index;" value="{{i+year}}">{{i+year}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-5 col-md-5 pull-right">
                                <div class="form-group">
                                    <label for="cardCVC">CVV CODE</label>
                                    <input [(ngModel)]="newCreditCard.cvc"
                                           #cvc
                                           class="form-control" id="newCVV"
                                           size="4" maxlength="4" required=""
                                           placeholder="CVC Code" value=""
                                           name="cardCVC" type="text"
                                           (keypress)="preventSpace(cvc.value, $event)"
                                           (keyup)="preventSpace(cvc.value, $event)"
                                           inputmode="numeric" pattern="[0-9]*" digitOnly>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer text-right">
                            <input (click)="clearNewCreditCardData()" type="button" class="btn" name="close" value="Cancel" />
                            <input (click)="generateJsonData()" [disabled]="!validCreditCard || newCreditCard.name == '' || newCreditCard.cvc == ''" type="button" class="btn btn-primary waves-effect" value="Add" />
                        </div>

                    </form>
                </div>
            </div>
            <!-- CREDIT CARD FORM ENDS HERE -->
        </div>
    </div>
</div>

<!--discount Modal-->
<div id="discountModal" class="modal top-right fade fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Purchase Assessments</h2>
                <button type="button" (click)="hideDiscountModal()" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">
                <p>We are sorry.  We were unable to determine the possible discounts associated to your account.  If you decide to continue no discounts -if available- will be applied to your order.  Do you want to continue?</p>
            </div>

            <div class="modal-footer">
                <div class="">
                    <div class="col-md-12">
                        <button (click)="hideDiscountModal()" type="button" class="btn btn-secondary">No</button>
                        <button (click)="displayPurchaseAssessmentModal()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

